import 'css-chunksrc/client/common/projectsSelection/input/styles.scss';export default {
  "input": "_input_8fa37_1",
  "opened": "_opened_8fa37_20",
  "toggleIcon": "_toggleIcon_8fa37_25",
  "placeholder": "_placeholder_8fa37_39",
  "folder": "_folder_8fa37_46",
  "icon": "_icon_8fa37_58",
  "tagIcon": "_tagIcon_8fa37_70"
};